import { useState } from "react";
import { Check, Trash2, FolderInput, Tag } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { can } from "@/lib/roles";
import { BulkSellDialog } from "@/components/wh/BulkSellDialog";
import { eurOr } from "@/lib/wh";

const n = (k, one, many) => `${k} ${k === 1 ? one : many}`;

export function MoveSelect({ lots, onPick, testid, label = "Sposta in" }) {
  return (
    <label className="btn-secondary h-9 px-3 text-sm relative" data-testid={testid}>
      <FolderInput className="h-4 w-4" /> {label}
      <select value="" onChange={(e) => onPick(e.target.value === "none" ? null : e.target.value)} className="absolute inset-0 opacity-0 cursor-pointer" aria-label={label} data-testid={`${testid}-select`}>
        <option value="" disabled>Scegli lotto</option>
        <option value="none">Da smistare (senza lotto)</option>
        {lots.map((l) => <option key={l.id} value={l.id}>{l.name}</option>)}
      </select>
    </label>
  );
}

export function BulkBar({ ids, lots, endpoint, onDone, kind = "items", canMove = true }) {
  const { user } = useAuth();
  const [sell, setSell] = useState(false);
  const run = async (body, msg) => {
    try { const { data } = await api.post(endpoint, { ids, ...body }); toast.success(msg(data)); onDone(); return true; } catch (e) { toast.error(formatApiError(e)); return false; }
  };
  const category = () => {
    const c = window.prompt(`Nuova categoria per ${n(ids.length, "articolo", "articoli")} (es. nome espansione):`);
    if (c !== null) run({ action: "category", category: c }, () => "Categoria aggiornata");
  };
  const del = () => {
    const extra = kind === "lots" ? " e TUTTI gli articoli contenuti" : "";
    if (window.prompt(`Eliminare definitivamente ${kind === "lots" ? n(ids.length, "lotto", "lotti") : n(ids.length, "articolo", "articoli")}${extra}? Nello storico resta traccia. Scrivi ELIMINA per confermare.`) === "ELIMINA") {
      run({ action: "delete" }, (d) => (kind === "lots" ? `Eliminati: ${n(d.lots, "lotto", "lotti")} e ${n(d.items, "articolo", "articoli")}` : `Eliminati: ${n(d.deleted, "articolo", "articoli")}`));
    }
  };
  if (!ids.length || !can(user, "wh_write")) return null;
  return (
    <div className="sticky top-16 lg:top-2 z-20 rounded-2xl bg-[var(--ink)] text-white p-3 flex flex-wrap gap-2 items-center shadow-xl" data-testid={`bulk-bar-${kind}`}>
      <span className="text-sm font-semibold mr-auto" data-testid={`bulk-count-${kind}`}>{kind === "lots" ? n(ids.length, "lotto selezionato", "lotti selezionati") : n(ids.length, "articolo selezionato", "articoli selezionati")}</span>
      <button onClick={() => setSell(true)} className="btn-primary h-9 px-3 text-sm" data-testid={`bulk-sell-${kind}`}><Check className="h-4 w-4" /> Venduti</button>
      {canMove && <MoveSelect lots={lots} testid={`bulk-move-${kind}`} label={kind === "lots" ? "Sposta articoli in" : "Sposta in"}
        onPick={(lot_id) => run({ action: "move", lot_id }, (d) => `Spostati: ${n(d.moved, "articolo", "articoli")}`)} />}
      {kind === "items" && <button onClick={category} className="btn-secondary h-9 px-3 text-sm" data-testid="bulk-category-items"><Tag className="h-4 w-4" /> Categoria</button>}
      {user.role === "admin" && <button onClick={del} className="btn-secondary h-9 px-3 text-sm text-red-600" data-testid={`bulk-delete-${kind}`}><Trash2 className="h-4 w-4" /> Elimina</button>}
      <BulkSellDialog open={sell} onOpenChange={setSell} count={ids.length}
        onConfirm={(b) => run({ action: "sell", ...b }, (d) => `Venduti: ${n(d.sold, "articolo", "articoli")} per ${eurOr(d.total)}`)} />
    </div>
  );
}
